/* **************************************************** Quotation share list */

import {
  CommonSharedByType,
  mapCommonSharedByType,
} from "../Share/CommonSharedByType";

/* Quotation share list */
export interface QuotationShareList {
  quotation_data_id: number;
  first_name: string;
  last_name: string | null;
  profile_image: string | null;
  mobile: string | null;
  landline: string | null;
  email: string | null;
  address: string | null;
  city: string | null;
  post_code: string | null;
  role_name: string | null;
  main_type: string | null;
  by: string;
  can_edit: 1 | 0;
  id: number;
  simple_permission_data:QuotationDetailPermissionData|null;
  detail_permission_data:QuotationDetailPermissionData|null;
}

export const mapQuotationShareList = (data: any): QuotationShareList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationShareList = {
    quotation_data_id: data.quotation_data_id,
    id: data.id,
    first_name: data.first_name,
    last_name: data.last_name || null,
    main_type: data.main_type ||null,
    profile_image: data.profile_image || null,
    mobile: data.mobile || null,
    landline: data.landline || null,
    email: data.email || null,
    address: data.address || null,
    city: data.city || null,
    post_code: data.post_code || null,
    role_name: data.role_name || null,
    by: data.by,
    can_edit: data.can_edit || 0,
     simple_permission_data: data.simple_permission_data? mapQuotationDetailPermissionData(data.simple_permission_data): null,
     detail_permission_data: data.detail_permission_data? mapQuotationDetailPermissionData(data.detail_permission_data): null,
  };

  return res;
};

export const mapQuotationShareLists = (data: any[]): QuotationShareList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapQuotationShareList);
};
/* **************************************************** */

/* **************************************************** Quotation detail permission data */
/* Quotation detail permission data */
export interface QuotationDetailPermissionData {
  header: string | null;
  footer: string | null;
  permission_list: string[];
}

export const mapQuotationDetailPermissionData = (
  data: any
): QuotationDetailPermissionData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationDetailPermissionData = {
    header: data.header || null,
    footer: data.footer || null,
    permission_list: Array.isArray(data.permission_list)
      ? data.permission_list
      : [],
  };

  return res;
};
/* **************************************************** */

/* **************************************************** Quotation simple permission data */
/* Quotation simple permission data */
export interface QuotationSimplePermissionData {
  header: string | null;
  footer: string | null;
  permission_list: string[];
}

export const mapQuotationSimplePermissionData = (
  data: any
): QuotationSimplePermissionData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationSimplePermissionData = {
    header: data.header || null,
    footer: data.footer || null,
    permission_list: Array.isArray(data.permission_list)
      ? data.permission_list
      : [],
  };

  return res;
};
/* **************************************************** */

/* **************************************************** Quotation term data */
/* Quotation term data */
export interface QuotationTermData {
  advance_payment: number | null;
  start_date: string | null;
  duration_type: "Week" | "Month" | null;
  duration: number | null;
}

export const mapQuotationTermData = (data: any): QuotationTermData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationTermData = {
    advance_payment: data.advance_payment || null,
    start_date: data.start_date || null,
    duration_type: data.duration_type || null,
    duration: data.duration || null,
  };

  return res;
};
/* **************************************************** */

/* **************************************************** Quotation sow data */
/* Quotation sow sub item simple data */
export interface SOWSubItemSimpleData {
  material: number | null;
  labour: number | null;
  total: number | null;
  final_total: number | null;
}

export const mapSOWSubItemSimpleData = (data: any): SOWSubItemSimpleData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWSubItemSimpleData = {
    material: data.material || null,
    labour: data.labour || null,
    total: data.total || null,
    final_total: data.final_total || null,
  };

  return res;
};

/* Quotation sow simple data sub item list */
export interface SOWSimpleDataSubItemList {
  id: number;
  quotation_item_id: number;
  quotation_sub_item_name: string | null;
  final_total: number | null;
  sub_item_simple_data: SOWSubItemSimpleData | null;
}

export const mapSOWSimpleDataSubItemList = (
  data: any
): SOWSimpleDataSubItemList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWSimpleDataSubItemList = {
    id: data.id,
    quotation_item_id: data.quotation_item_id,
    quotation_sub_item_name: data.quotation_sub_item_name || null,
    final_total: data.final_total || null,
    sub_item_simple_data: data.sub_item_simple_data
      ? mapSOWSubItemSimpleData(data.sub_item_simple_data)
      : null,
  };

  return res;
};

export const mapSOWSimpleDataSubItemLists = (
  data: any[]
): SOWSimpleDataSubItemList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapSOWSimpleDataSubItemList);
};

/* Quotation sow simple data list */
export interface SOWSimpleDataList {
  id: number;
  quotation_item_name: string | null;
  status: 1 | 0;
  item_total: number | null;
  sub_item_list: SOWSimpleDataSubItemList[];
}

export const mapSOWSimpleDataList = (data: any): SOWSimpleDataList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWSimpleDataList = {
    id: data.id,
    quotation_item_name: data.quotation_item_name || null,
    status: data.status,
    item_total: data.item_total || null,
    sub_item_list: Array.isArray(data.sub_item_list)
      ? mapSOWSimpleDataSubItemLists(data.sub_item_list)
      : [],
  };

  return res;
};

export const mapSOWSimpleDataLists = (data: any[]): SOWSimpleDataList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapSOWSimpleDataList);
};

/* Quotation sow simple data */
export interface SOWSimpleData {
  simple_data_total: number | null;
  simple_data_list: SOWSimpleDataList[];
}

export const mapSOWSimpleData = (data: any): SOWSimpleData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWSimpleData = {
    simple_data_total: data.simple_data_total || null,
    simple_data_list: Array.isArray(data.simple_data_list)
      ? mapSOWSimpleDataLists(data.simple_data_list)
      : [],
  };

  return res;
};

/* SOW sub item unit data */
export interface SOWSubItemUnitData {
  id: number;
  unit_name: string;
  status: 1 | 0;
}

export const mapSOWSubItemUnitData = (data: any): SOWSubItemUnitData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWSubItemUnitData = {
    id: data.id,
    unit_name: data.unit_name,
    status: data.status,
  };

  return res;
};

/* Quotation sow sub item detail data */
export interface SOWSubItemDetailData {
  unit_id: number | null;
  quantity: number | null;
  unit_price: number | null;
  material_cost: number | null;
  labour_cost: number | null;
  unit: SOWSubItemUnitData | null;
}

export const mapSOWSubItemDetailData = (data: any): SOWSubItemDetailData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWSubItemDetailData = {
    unit_id: data.unit_id || null,
    quantity: data.quantity || null,
    unit_price: data.unit_price || null,
    material_cost: data.material_cost || null,
    labour_cost: data.labour_cost || null,
    unit: data.unit ? mapSOWSubItemUnitData(data.unit) : null,
  };

  return res;
};

/* Quotation sow detail data sub item list */
export interface SOWDetailDataSubItemList {
  id: number;
  quotation_item_id: number;
  quotation_sub_item_name: string | null;
  final_total: number | null;
  sub_item_detail_data: SOWSubItemDetailData | null;
}

export const mapSOWDetailDataSubItemList = (
  data: any
): SOWDetailDataSubItemList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWDetailDataSubItemList = {
    id: data.id,
    quotation_item_id: data.quotation_item_id,
    quotation_sub_item_name: data.quotation_sub_item_name || null,
    final_total: data.final_total || null,
    sub_item_detail_data: data.sub_item_detail_data
      ? mapSOWSubItemDetailData(data.sub_item_detail_data)
      : null,
  };

  return res;
};

export const mapSOWDetailDataSubItemLists = (
  data: any[]
): SOWDetailDataSubItemList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapSOWDetailDataSubItemList);
};

/* Quotation sow detail data list */
export interface SOWDetailDataList {
  id: number;
  quotation_item_name: string | null;
  status: 1 | 0;
  item_total: number | null;
  sub_item_list: SOWDetailDataSubItemList[];
}

export const mapSOWDetailDataList = (data: any): SOWDetailDataList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWDetailDataList = {
    id: data.id,
    quotation_item_name: data.quotation_item_name || null,
    status: data.status,
    item_total: data.item_total || null,
    sub_item_list: Array.isArray(data.sub_item_list)
      ? mapSOWDetailDataSubItemLists(data.sub_item_list)
      : [],
  };

  return res;
};

export const mapSOWDetailDataLists = (data: any[]): SOWDetailDataList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapSOWDetailDataList);
};

/* Quotation sow detail data */
export interface SOWDetailData {
  detail_data_total: number | null;
  detail_data_list: SOWDetailDataList[];
}

export const mapSOWDetailData = (data: any): SOWDetailData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: SOWDetailData = {
    detail_data_total: data.detail_data_total || null,
    detail_data_list: Array.isArray(data.detail_data_list)
      ? mapSOWDetailDataLists(data.detail_data_list)
      : [],
  };

  return res;
};

/* Quotation sow data */
export interface QuotationSOWData {
  simple_data: SOWSimpleData | null;
  detail_data: SOWDetailData | null;
}

export const mapQuotationSOWData = (data: any): QuotationSOWData => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationSOWData = {
    simple_data: data.simple_data ? mapSOWSimpleData(data.simple_data) : null,
    detail_data: data.detail_data ? mapSOWDetailData(data.detail_data) : null,
  };

  return res;
};
/* **************************************************** */

/* **************************************************** Quotation note list */
/* Quotation note list */
export interface QuotationNoteList {
  id: number;
  quotation_data_id: number;
  note_type: "Default" | string;
  note_default_id: number | null;
  note_no: number | null;
  note: string | null;
}

// Single object mapping
export const mapQuotationNoteList = (data: any): QuotationNoteList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationNoteList = {
    id: data.id,
    quotation_data_id: data.quotation_data_id,
    note_type: data.note_type,
    note_default_id: data.note_default_id || null,
    note_no: data.note_no || null,
    note: data.note || null,
  };

  return res;
};

// List mapping
export const mapQuotationNoteLists = (data: any[]): QuotationNoteList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapQuotationNoteList);
};
/* **************************************************** */

/* **************************************************** Quotation cover page */
/* Quotation Cover Page */
export interface QuotationCoverPage {
  id: number;
  quotation_id: number;
  comapany_logo: string | null;
  comapany_name: string | null;
  project_description: string | null;
  project_address: string | null;
  client_name: string | null;
}

// Single object mapping
export const mapQuotationCoverPage = (data: any): QuotationCoverPage => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationCoverPage = {
    id: data.id,
    quotation_id: data.quotation_id,
    comapany_logo: data.comapany_logo || null,
    comapany_name: data.comapany_name || null,
    project_description: data.project_description || null,
    project_address: data.project_address || null,
    client_name: data.client_name || null,
  };

  return res;
};
/* **************************************************** */

/* Quotation list */
export interface QuotationList {
  id: number;
  quotation_id: number;
  quotation_no: string | null;
  date: string | null;
  status: "Draft" | "Complete";
  generate_report: 1 | 0;
  sign_report: 1 | 0;
  sign: string | null;
  sign_date: string | null;
  detail_generate_report: 1 | 0;
  detail_sign_report: 1 | 0;
  detail_sign: string | null;
  detail_sign_date: string | null;
  simple_report_download_path: string | null;
  detail_report_download_path: string | null;
  can_edit: boolean;
  cover_page_data: QuotationCoverPage | null;
  note_list: QuotationNoteList[];
  sow_data: QuotationSOWData | null;
  term_data: QuotationTermData | null;
  simple_permission_data: QuotationSimplePermissionData | null;
  detail_permission_data: QuotationDetailPermissionData | null;
  share_list: QuotationShareList[];
  shared_by: CommonSharedByType | null;
}

export const mapQuotationList = (data: any): QuotationList => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: QuotationList = {
    id: data.id,
    quotation_id: data.quotation_id,
    quotation_no: data.quotation_no || null,
    date: data.date || null,
    status: data.status,
    generate_report: data.generate_report,
    sign_report: data.sign_report,
    sign: data.sign || null,
    sign_date: data.sign_date || null,
    detail_generate_report: data.detail_generate_report,
    detail_sign_report: data.detail_sign_report,
    detail_sign: data.detail_sign || null,
    detail_sign_date: data.detail_sign_date || null,
    simple_report_download_path: data.simple_report_download_path || null,
    detail_report_download_path: data.detail_report_download_path || null,
    can_edit: data.can_edit,
    cover_page_data: data.cover_page_data
      ? mapQuotationCoverPage(data.cover_page_data)
      : null,
    note_list: Array.isArray(data.note_list)
      ? mapQuotationNoteLists(data.note_list)
      : [],
    sow_data: data.sow_data ? mapQuotationSOWData(data.sow_data) : null,
    term_data: data.term_data ? mapQuotationTermData(data.term_data) : null,
    simple_permission_data: data.simple_permission_data
      ? mapQuotationSimplePermissionData(data.simple_permission_data)
      : null,
    detail_permission_data: data.detail_permission_data
      ? mapQuotationDetailPermissionData(data.detail_permission_data)
      : null,
    share_list: Array.isArray(data.share_list)
      ? mapQuotationShareLists(data.share_list)
      : [],
    shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
  };

  return res;
};

export const mapQuotationLists = (data: any[]): QuotationList[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapQuotationList);
};

/* Quotation */
export interface Quotation {
  id: number;
  project_id: number | null;
  folder_id: number | null;
  category: "Custom" | "Template" | null;
  date: string | null;
  template_id: number | null;
  project_address: string | null;
  project_reference: string | null;
  created_by: number | null;
  quotation_no: number | null;
  type: "Own" | "Shared" | null;
  quotation_data: QuotationList[];
    shared_by: CommonSharedByType | null;
}

export const mapQuotation = (data: any): Quotation => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: Quotation = {
    id: data.id,
    project_id: data.project_id || null,
    folder_id: data.folder_id || null,
    category: data.category || null,
    date: data.date || null,
    template_id: data.template_id || null,
    project_address: data.project_address || null,
    project_reference: data.project_reference || null,
    created_by: data.created_by || null,
    quotation_no: data.quotation_no || null,
    type: data.type || null,
    quotation_data: Array.isArray(data.quotation_data)
      ? mapQuotationLists(data.quotation_data)
      : [],
      shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
  };

  return res;
};

export const mapQuotations = (data: any[]): Quotation[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapQuotation);
};

/* Material data unit */
export interface MaterialDataUnit {
  id: number;
  unit_name: string;
  status: 1 | 0;
}

export const mapMaterialDataUnit = (data: any): MaterialDataUnit => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: MaterialDataUnit = {
    id: data.id,
    unit_name: data.unit_name,
    status: data.status,
  };

  return res;
};

export const mapMaterialDataUnits = (data: any[]): MaterialDataUnit[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapMaterialDataUnit);
};
